<template>
    <div class="sign-up-partner">
        <div class="sign-up-partner__content">
            <vs-row>
                <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="5" vs-sm="12" vs-xs="12"
                        style="flex-direction:column">
                    <div class="sign-up-partner__content-box sign-up-partner__content-box--stretch"
                         :class="{ 'sign-up-partner__content-box--white': isDesktop }">
                        <div class="sign-up-partner__content-filoo">
                            <img :src="imgLogoFiloo" class="sign-up-partner__content-filoo-logo"/>
                        </div>

                        <slot v-if="isDesktop"/>
                    </div>
                </vs-col>
                <vs-col vs-lg="7" vs-sm="12" vs-xs="12">
                    <div class="sign-up-partner__content-banner"/>

                    <slot v-if="!isDesktop"/>
                </vs-col>
            </vs-row>
        </div>
    </div>
</template>

<script>
import {computed, defineComponent} from 'vue'

import {useStore} from "@/store/store.js"
import imgLogoFiloo from "@/assets/images/logo.png"
import imgBanner from "@/assets/images/SignUp/banner.jpeg"

export default defineComponent({
    name: "SignUpHeader",

    setup() {
        const store = useStore()

        return {
            device: computed(() => store.getters.device),
            imgLogoFiloo,
            imgBanner
        }
    },

    computed: {
        isDesktop() {
            return this.device === 'desktop'
        }
    }
})
</script>

<style lang="scss" scoped>
.sign-up-partner {
    $this: &;

    &__content {
        align-items: center;
        display: inline-flex;
        gap: 1rem;
        justify-content: center;
        width: 100%;

        @media #{$md-and-up} {
            gap: 2rem;
        }

        &-box {
            border-radius: .5rem;
            padding: .75rem;
            width: 100%;

            &:not(:first-child) {
                margin-top: 1rem;
            }

            &--stretch {
                display: flex;
                flex-direction: column;
                flex-grow: 1;
            }

            &--gray {
                background-color: #F0F1F2;
            }

            &--white {
                background-color: #FFF;
            }
        }

        &-filoo {
            align-items: center;
            display: flex;
            flex-direction: column;
            flex-grow: 1;
            justify-content: center;

            &-logo {
                width: 55px;

                @media #{$md-and-up} {
                    width: 80px;
                }

                @media #{$lg-and-up} {
                    width: 120px;
                }
            }

            &:last-child {
                #{$this}__content-filoo-logo {
                    @media #{$lg-and-up} {
                        width: 200px;
                    }
                }
            }
        }

        &-banner {
            background-image: url(@/assets/images/SignUp/banner.jpeg);
            background-position: center;
            background-size: cover;
            border-radius: .5rem;
            height: 200px;
            width: 100%;

            @media #{$md-and-up} {
                height: 250px;
            }

            @media #{$lg-and-up} {
                height: 290px;
            }

            @media #{$xl-and-up} {
                height: 340px;
            }
        }

        &-partner {
            align-items: center;
            display: flex;
            justify-content: center;

            &-label {
                font-size: .75rem;
                font-weight: 600;
                text-transform: uppercase;

                @media #{$md-and-up} {
                    font-size: .875rem;
                }

                @media #{$lg-and-up} {
                    font-size: 1rem;
                }

                @media #{$xl-and-up} {
                    font-size: 1.125rem;
                }
            }

            &-name {
                font-size: .75rem;
                font-weight: 600;
                margin-left: 1.5rem;
                text-transform: uppercase;

                @media #{$md-and-up} {
                    font-size: .875rem;
                }

                @media #{$lg-and-up} {
                    font-size: 1rem;
                }

                @media #{$xl-and-up} {
                    font-size: 1.125rem;
                }
            }

            &-logo {
                margin-left: 1rem;
                max-height: 50px;
                max-width: 100px;

                @media #{$md-and-up} {
                    margin-left: 1.5rem;
                    max-height: 85px;
                    max-width: 170px;
                }
            }
        }


        /*
        &-text {
          flex-grow: 1;
          font-size: 1rem;
          font-weight: 400;
          line-height: 1.25rem;
          text-align: center;
          width: 150px;

          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          white-space: normal;

          &--half {
            max-width: 50%!important;
          }

          &--full {
            max-width: 100%!important;
          }

          @media #{$md-and-up} {
            flex-grow: 0;
            font-size: 1.625rem;
            line-height: 2rem;
            max-width: 100%;
            width: auto;
            -webkit-line-clamp: unset;
            display: block;
          }
        }
        */
    }

    .partner-name {
        display: block;
        color: orange;

        @media #{$md-and-up} {
            display: inline;
        }
    }
}
</style>
